'use strict'

const pluginsManager = require('./pluginsManager')()
const fixPageData = require('./fixPageData')(pluginsManager)
module.exports = fixPageData
